/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for report types.
 * @export
 * @interface ReportType
 */
export interface ReportType {
  /**
   *
   * @type {number}
   * @memberof ReportType
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof ReportType
   */
  name: string;
}

/**
 * Check if a given object implements the ReportType interface.
 */
export function instanceOfReportType(value: object): value is ReportType {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function ReportTypeFromJSON(json: any): ReportType {
  return ReportTypeFromJSONTyped(json, false);
}

export function ReportTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportType {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
  };
}

export function ReportTypeToJSON(value?: Omit<ReportType, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
  };
}
